const base64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAABCAQAAABA4oeyAAAADklEQVR42mNk+M+AFQAAFxsBAcv5lZcAAAAASUVORK5CYII=';

export default base64;